import React, { ErrorInfo, ReactNode } from 'react'

import analyticsServiceSingleton from '../services/Analytics/initAnalytics'

interface ErrorBoundaryProps {
  children: ReactNode
  fallback?: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    // Still track that an error occurred but we won't block the UI
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Track the error using analyticsServiceSingleton
    analyticsServiceSingleton.trackError(error, {
      componentStack: errorInfo.componentStack
    })

    // Log the error to console
    console.error('Error caught by ErrorBoundary:', error)
    console.error('Component stack:', errorInfo.componentStack)
  }

  render() {
    // Always render children to allow continued interaction,
    // even when an error has occurred
    return this.props.children
  }
}

export default ErrorBoundary
